import { MediaType } from '../MediaType';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

export const experimentalFileUpload: ExperimentalMutations['experimentalFileUpload'] = (
	_,
	args,
	{ network: { cfetch } },
) =>
	cfetch(`/wiki/rest/drag-and-drop/1/filestore/upload`, {
		method: 'POST',
		body: JSON.stringify(args),
		headers: {
			'Content-Type': MediaType.JSON,
		},
	}).then(() => true);
